import { get, post, put, del } from '../../../../GlobalModules/Utility/Http'
import * as KitchenDisplayModel from '../Model/KitchenDisplayModel'

// Cache for categories to prevent multiple API calls
let categoriesCache = null
let categoriesCacheTime = null
const CACHE_DURATION = 5 * 60 * 1000 // 5 minutes

// Function to fetch available categories from API with caching
export const getCategoriesApi = async () => {
  try {
    // Check if we have valid cached data
    const now = Date.now()
    if (
      categoriesCache &&
      categoriesCacheTime &&
      now - categoriesCacheTime < CACHE_DURATION
    ) {
      console.log('Using cached categories data')
      return { success: true, data: categoriesCache }
    }

    const queryParams = {
      filters: JSON.stringify({ status: 1, store_id: localStorage.getItem('store_id') })
    }
    const response = await get(
      `${process.env.EXTENDED_URL}category`,
      queryParams
    )
    console.log('Categories API Response:', response)

    if (response && response.data && response.data.success === true) {
      const categories = Array.isArray(response.data.data)
        ? response.data.data.map((cat) => ({
            id: cat.id,
            name: cat.name || cat.label || cat.category_name || 'Unknown'
          }))
        : []

      // Cache the result
      categoriesCache = categories
      categoriesCacheTime = now

      return { success: true, data: categories }
    }
    return { success: false, data: [], message: 'Failed to fetch categories' }
  } catch (error) {
    console.error('Error fetching categories:', error)
    return {
      success: false,
      data: [],
      message: error?.message || 'Failed to fetch categories'
    }
  }
}

export const getKitchenDisplayList = async (filters = {}) => {
  let queryParams = {}

  if (filters) {
    const filtersObj = {
      limit: filters.limit || 10,
      offset: filters.offset || 0
    }

    // Add store_id filter if provided
    if (filters.store_id) {
      filtersObj.store_id = filters.store_id
    }

    if (filters.search) {
      queryParams.filter_op = JSON.stringify({ search_attr: 'substring' })
      filtersObj.search_attr = filters.search
    }

    // Add sorting if provided
    if (filters.sort && filters.sort.length > 0) {
      filtersObj.sort = [
        {
          field: filters.sort[0].field,
          sort: filters.sort[0].sort
        }
      ]
    } else {
      // Default sorting
      filtersObj.sort = [
        {
          field: 'createdAt',
          sort: 'desc'
        }
      ]
    }

    queryParams.filters = JSON.stringify(filtersObj)
  }

  console.log('API Request URL:', `${process.env.EXTENDED_URL}kitchen_display`)
  console.log('API Request Params:', queryParams)

  const response = await get(
    `${process.env.EXTENDED_URL}kitchen_display`,
    queryParams
  )
  return KitchenDisplayModel.kitchenDisplayListGet(response)
}

export const getKitchenDisplayDetails = async (slack) => {
  try {
    const response = await get(
      `${process.env.EXTENDED_URL}kitchen_display/${slack}`
    )

    const result = KitchenDisplayModel.kitchenDisplayDetailsGet(response)
    console.log('Initial result from model:', result)

    // If we have categories but they're just IDs, fetch the full category details
    if (
      result.success &&
      result.data.categories &&
      result.data.categories.length > 0
    ) {
      console.log('Categories found:', result.data.categories)
      const categoriesResponse = await getCategoriesApi()
      if (categoriesResponse.success) {
        const categoryMap = {}
        categoriesResponse.data.forEach((cat) => {
          categoryMap[cat.id] = cat
        })

        // Replace category IDs with full category objects
        result.data.categories = result.data.categories.map((category) => {
          console.log(
            'Processing category:',
            category,
            'Type:',
            typeof category
          )
          if (typeof category === 'object' && category.id) {
            const mappedCategory = categoryMap[category.id] || category
            console.log('Mapped object category:', mappedCategory)
            return mappedCategory
          }
          const mappedCategory = categoryMap[category] || {
            id: category,
            name: `Category ${category}`
          }
          console.log('Mapped ID category:', mappedCategory)
          return mappedCategory
        })
        console.log('Final categories after mapping:', result.data.categories)
      }
    }

    return result
  } catch (error) {
    console.error('Error fetching kitchen display details:', error)
    return {
      success: false,
      message: 'Failed to fetch kitchen display details',
      data: {}
    }
  }
}

export const createKitchenDisplay = async (payload) => {
  console.log('Creating Kitchen Display with payload:', payload) // Debug log

  const response = await post(
    `${process.env.EXTENDED_URL}kitchen_display`,
    payload
  )
  return KitchenDisplayModel.kitchenDisplayCreatePost(response)
}

export const updateKitchenDisplay = async (slack, payload) => {
  console.log('Updating Kitchen Display with payload:', payload) // Debug log

  const response = await put(
    `${process.env.EXTENDED_URL}kitchen_display/${slack}`,
    payload
  )
  return KitchenDisplayModel.kitchenDisplayUpdatePut(response)
}

export const deleteKitchenDisplay = async (slack) => {
  try {
    console.log('Deleting Kitchen Display with slack:', slack)
    const response = await del(
      `${process.env.EXTENDED_URL}kitchen_display/${slack}`
    )
    console.log('Delete API Response:', response)
    return KitchenDisplayModel.kitchenDisplayDeleteDel(response)
  } catch (error) {
    console.error('Error deleting Kitchen Display:', error)
    return {
      success: false,
      message: error?.message || 'Failed to delete Kitchen Display'
    }
  }
}
